export default "__VITE_ASSET__DjS_1vJ0__"